define('gamebox/input', ['exports', 'module', 'eventmap', './key'], function (exports, module, _eventmap, _key) {
  'use strict';

  function _interopRequire(obj) { return obj && obj.__esModule ? obj['default'] : obj; }

  var _EventMap = _interopRequire(_eventmap);

  var _Key = _interopRequire(_key);

  'use strict';

  var Input = {};

  Input.Key = _Key;
  Input.define = _Key.define;

  // TODO: Find a different name
  Input.key = new _EventMap();

  window.addEventListener('keydown', function (evt) {
    Input.key.trigger({
      name: 'down',
      context: _Key
    }, evt.keyCode);
  }, true);

  window.addEventListener('keyup', function (evt) {
    Input.key.trigger({
      name: 'up',
      context: _Key
    }, evt.keyCode);
  }, true);

  module.exports = Input;
});